import type AgencyAssociatedWorkersTableVM from 'ab-viewModels/agency/associatedWorkersTable.viewModel';

const WORKERS_TABLE_CSV_HEADER = [
	'Name',
	'Total Wo',
];

export const toCSVData = (viewModels: AgencyAssociatedWorkersTableVM[]): string[][] => {
	const header: string[] = [...WORKERS_TABLE_CSV_HEADER];
	const rows: string[][] = [];

	viewModels.forEach((_employee) => {
		rows.push([
			`${_employee.lastName},${_employee.firstName}`,
			_employee.totalWorkOrders.toString(),
		]);
	});

	return [header, ...rows];
};
